import { render, staticRenderFns } from "./omsetedisi_chart.vue?vue&type=template&id=42b0d8ca"
import script from "./omsetedisi_chart.vue?vue&type=script&lang=js"
export * from "./omsetedisi_chart.vue?vue&type=script&lang=js"
import style0 from "./omsetedisi_chart.vue?vue&type=style&index=0&id=42b0d8ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports